// extracted by mini-css-extract-plugin
export default {"wave":"Banner_wave__SX+Qn","wave-animation":"Banner_wave-animation__WQdX3"};